/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicProcessAlertTemplateStatusUpdate extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicProcessAlertTemplateStatusUpdate");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicProcessAlertTemplateStatusUpdate.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicProcessAlertTemplateStatusUpdate>): BackgroundJobPayloadForPeriodicProcessAlertTemplateStatusUpdate {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicProcessAlertTemplateStatusUpdate(), model);
        BackgroundJobPayloadForPeriodicProcessAlertTemplateStatusUpdate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicProcessAlertTemplateStatusUpdate>): BackgroundJobPayloadForPeriodicProcessAlertTemplateStatusUpdate {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicProcessAlertTemplateStatusUpdate.newInstance(<BackgroundJobPayloadForPeriodicProcessAlertTemplateStatusUpdate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicProcessAlertTemplateStatusUpdate) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicProcessAlertTemplateStatusUpdate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicProcessAlertTemplateStatusUpdate): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicProcessAlertTemplateStatusUpdate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
